import type {AttributeMetaData} from 'src/types/writeback';
import type {EntityType} from 'src/types/ats-entities';
import type {DynamicLabelExtra} from 'src/types/dynamic-labels';

import * as React from 'react';
import {useSelector} from 'react-redux';

import {useWritebackAttributesAsOptions} from 'src/hooks/useWritebackAllowedAttributes';
import {createDynamicLabelSelector} from 'src/selectors/dynamic-labels';

import VariablePickerSelect from 'src/components/lib/variable-picker/select-2';

import css from './variable-picker.css';


const selectVariablePickerOptions = createDynamicLabelSelector({
  depth: 2,
});

export default function LoadedVariablePicker({
  entityType,
  value,
  attributeMetadata,
  onChange,
  readOnly,
  error,
}: {
  entityType: EntityType;
  value: string | null | undefined;
  attributeMetadata: Array<AttributeMetaData> | null | undefined;
  onChange: (arg1?: AttributeMetaData | null | undefined) => unknown;
  readOnly?: unknown;
  error?: unknown;
}) {
  const options = useWritebackAttributesAsOptions(
    entityType,
    attributeMetadata || [],
  );

  const selectedOption = options.find((option) => option.attributeId === value);

  return (
    // @ts-expect-error - TS2739 - Type '{ classNames: { container: string; }; baseEntityType: EntityType; options: any[]; values: any[]; limit: number; onChange: (values: any[]) => void; allowArbitraryValues: false; disabled: unknown; error: unknown; }' is missing the following properties from type 'SenseTypeaheadProps<any>': resolveKey, resolveLabel
    <VariablePickerSelect
      classNames={{container: css.container}}
      baseEntityType={entityType}
      options={options}
      values={selectedOption ? [selectedOption] : []}
      limit={1}
      onChange={(values) => {
        const attributeName = values[0]?.attributeName;
        onChange(
          attributeName &&
            attributeMetadata?.find(
              (attr: AttributeMetaData) =>
                attr.attribute_name === attributeName,
            ),
        );
      }}
      allowArbitraryValues={false}
      disabled={readOnly}
      error={error}
    />
  );
}

export function AllVariablePicker({
  entityType,
  value,
  onChange,
  readOnly,
  className,
  placeholder,
  hasLabel,
  error,
  inputProps,
  type,
}: {
  entityType: EntityType;
  value: string | null | undefined;
  onChange: (arg1?: DynamicLabelExtra | null | undefined) => unknown;
  readOnly?: unknown;
  className?: string | null | undefined;
  placeholder?: string | null | undefined;
  hasLabel?: boolean;
  error?: unknown;
  inputProps?: React.ComponentProps<'input'>;
  type?: string;
}) {
  const options = useSelector((state) =>
    selectVariablePickerOptions(state, entityType),
  );
  const selectedOption = options.find((option) => option.value === value);

  const filteredOptions = React.useMemo(
    () =>
      // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
      ['phone', 'email'].includes(type)
        ? options.filter((o) => o.type === type)
        : options,
    [options, type],
  );

  return (
    // @ts-expect-error - TS2739 - Type '{ classNames: { outerContainer: string | null | undefined; }; baseEntityType: EntityType; options: any[]; values: any[]; limit: number; onChange: (values: any[]) => void; allowArbitraryValues: false; ... 4 more ...; inputProps: DetailedHTMLProps<...> | undefined; }' is missing the following properties from type 'SenseTypeaheadProps<any>': resolveKey, resolveLabel
    <VariablePickerSelect
      classNames={{outerContainer: className}}
      baseEntityType={entityType}
      options={filteredOptions}
      values={selectedOption ? [selectedOption] : []}
      limit={1}
      onChange={(values) => {
        onChange(values[0]);
      }}
      allowArbitraryValues={false}
      disabled={readOnly}
      placeholder={placeholder}
      hasLabel={hasLabel}
      error={error}
      inputProps={inputProps}
    />
  );
}
